const name = {
  key: 'name',
  label: 'ブランド名',
  question: '出店するデリバリーサービスのブランド名',
} as const;

const tableColumns = [{ ...name, width: '200px' }] as const;

export const brandTableThs = tableColumns.map((tableColumn) => {
  return {
    label: tableColumn.label,
    minWidth: tableColumn.width,
    question: tableColumn.question,
  };
});
